import React from 'react'

const VerticalRoad = ({ company, setTab }) => {
    const cLevel = company?.cLevel || 'None';

    const handleNavigateToCertification = () => {
        window.location.hash = '#unaudited-certification';
        setTab('unaudited-certification');
    }

    // Calculate position based on cLevel
    const getPosition = () => {
        switch (cLevel) {
            case 'None':
                return { top: '1%' };
            case 'Bronze':
                return { top: '1%' };
            case 'Silver':
                return { top: '1%' };
            case 'Gold':
                return { bottom: '1%' };
            default:
                return { top: '1%' };
        }
    };

    // Get transform based on cLevel
    const getTransform = () => {
        switch (cLevel) {
            case 'None':
                return 'translateX(-50%)';
            case 'Bronze':
            case 'Silver':
                return 'translateX(-50%) translateY(-50%)';
            case 'Gold':
                return 'translateX(-50%)';
            default:
                return 'translateX(-50%)';
        }
    };

    const getJourneyImageSrc = () => {

        switch (company?.['testType']) {
            case 'investment':
                return require(`../../../../images/dashboard/growth.png`);
            case 'growth':
                return require(`../../../../images/dashboard/exit.png`);
            case 'exit':
                return require(`../../../../images/dashboard/investment.png`);
            default:
                return require(`../../../../images/dashboard/exit.png`);
        }
    };

    // Get image source based on cLevel
    const getImageSrc = () => {
        switch (cLevel) {
            case 'None':
                return require(`../../../../images/certifications/newCertificates/none.png`);
            case 'Bronze':
                return require(`../../../../images/certifications/newCertificates/bronze.png`);
            case 'Silver':
                return require(`../../../../images/certifications/newCertificates/silver.png`);
            case 'Gold':
                return require(`../../../../images/certifications/newCertificates/gold.png`);
            default:
                return require(`../../../../images/certifications/newCertificates/none.png`);
        }
    };

    return (
        <div className="df fdc aic pr mt1rem ml1rem" style={{ width: "43px", paddingBottom: "130px" }}>
            <div className="pr road df jcc" style={{ height: '100%', width: '100%' }}>
                <span className='db' style={{ height: '100%', width: '3px', borderLeft: '3px solid transparent', borderImage: 'repeating-linear-gradient( to bottom, white 0, white 10px,  transparent 10px, transparent 20px ) 1' }}></span>
                <img src={require(`../../../../images/certifications/newCertificates/yellowDownArrow.png`)} style={{ position: 'absolute', top: '8px', left: 'calc(50%)', transform: 'translateX(-50%)', maxHeight: '120px' }} alt="None" />
                {cLevel && (
                    <img
                        src={getImageSrc()}
                        onClick={() => handleNavigateToCertification()}
                        className="w70px pa zi1 cp"
                        alt={cLevel}
                        style={{
                            ...getPosition(),
                            left: '50%',
                            transform: getTransform(),
                        }}
                    />
                )}
                <img src={getJourneyImageSrc()} style={{ position: 'absolute', bottom: '-50px', left: 'calc(50%)', transform: 'translateX(-50%)', maxHeight: '120px' }} alt="None" />
            </div>
        </div>
    )
}

export default VerticalRoad